import controller from './new-products.controller';
import template from './new-products.view.html';

let NewProductsComponent = {
  template,
  controller,
  bindings : {
    shCtrl : '<'
  }
};

export default NewProductsComponent;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/catalog/new-products/new-products.component.js
 **/